import core from "@gtmhub/core/module";
import insightsCore from "@gtmhub/insights/insights-core.module";

import { KpiFormCtrl } from "./controllers/form";
import { KpiGroupingFormCtrl, KpiGroupingFormOpener } from "./controllers/grouping-form";
import { KpiService } from "./services/kpiService";
import { KpisCtrl } from "./controllers/kpis";

export default angular
  .module("kpis", [core, insightsCore])
  .controller("KpiFormCtrl", KpiFormCtrl)
  .controller("KpiGroupingFormCtrl", KpiGroupingFormCtrl)
  .service("KpiGroupingFormOpener", KpiGroupingFormOpener)
  .controller("KpisCtrl", KpisCtrl)
  .service("KpiService", KpiService).name;
